module.exports = __webpack_public_path__ + "static/img/propTechGood.8a7bdf81.png";